import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useMyVW } from '../../context/myVWContext';

interface UseMyVWBootstrapOptions {
  onBootstrapped?: () => boolean;
}

interface UseMyVWBootstrapResult {
  token: string;
  brand: string;
  country: string;
  hasBootstrapParams: boolean;
}

export const useMyVWBootstrap = (
  options?: UseMyVWBootstrapOptions,
): UseMyVWBootstrapResult => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const {
    init,
    token: contextToken,
    brand: contextBrand,
    country: contextCountry,
  } = useMyVW();

  const tokenParam = searchParams.get('token') ?? '';
  const brandParam = searchParams.get('brand') ?? '';
  const countryParam = searchParams.get('country') ?? '';

  const token = tokenParam || contextToken;
  const brand = brandParam || contextBrand;
  const country = countryParam || contextCountry;

  const hasBootstrapParams = Boolean(tokenParam || brandParam || countryParam);
  const hasRequiredBootstrapParams = Boolean(tokenParam && brandParam && countryParam);
  const urlBootstrapped = useRef(false);
  const optionsRef = useRef(options);

  // Cache options reference to avoid effect re-runs on every render
  // (rerender-dependencies pattern)
  optionsRef.current = options;

  useEffect(() => {
    if (urlBootstrapped.current) return;
    if (!hasRequiredBootstrapParams) {
      return;
    }

    urlBootstrapped.current = true;

    init({
      token: tokenParam,
      brand: brandParam,
      country: countryParam,
    });

    
    // window.history.replaceState(null, '', location.pathname);
    
  }, [
    brandParam,
    countryParam,
    hasRequiredBootstrapParams,
    init,
    location.pathname,
    tokenParam,
  ]);

  return {
    token,
    brand,
    country,
    hasBootstrapParams,
  };
};
